import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

export default function useDeletePrivateVehicle() {
  const [loading, setLoading] = useState(false);

  async function execute(vehicleId: string, callback: () => void) {
    try {
      setLoading(true);

      const response = await api.delete(`v1/api/vehicles/${vehicleId}`, {});

      if (callback) {
        callback();
      }

      if (response.status === 204) {
        toast.success(ToastMessages.vehicle.success.delete);
      }
    } catch (error: any) {
      const errorData = error.response.data;

      if (!Array.isArray(errorData.message)) {
        if (errorData.message)
          toast.error(`Erro de validação: ${errorData.message}`);
        else toast.error(ToastMessages.general.error.genericError);
      } else {
        errorData.message.map((msg: string) =>
          toast.error(`Erro de validação: ${msg}`),
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
